import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { DomainCode } from '../../models/common/model';
import { BackendListModel } from '../../models/common/list.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomainCodeApiService {
  base_url = ApiRoutes.DomainCode;

  constructor(
    private http: HttpClient
  ) { }

  getByGroup(group: string=null, group_startswith: string=null, page_size=1000): Observable<BackendListModel<DomainCode>> {
    let url = new URL(`${this.base_url}`);

    if (group) {
      url.searchParams.append('group', group);
    }
    if (group_startswith) {
      url.searchParams.append('group_startswith', group_startswith);
    }
    url.searchParams.append('page_size', page_size.toString());

    return this.http.get<BackendListModel<DomainCode>>(url.toString());
  }

  getByID(id: string): Observable<BackendListModel<DomainCode>> {
    let url = `${this.base_url}${id}/`;
    return this.http.get<BackendListModel<DomainCode>>(url);
  }

  // Delete details by ID
  // deleteByID(id: string): Observable<BackendListModel<DomainCode>> {
  //   let url = `${this.base_url}${id}`;
  //   return this.http.get<BackendListModel<DomainCode>>(url);
  // }
}
